const EMAIL_REGEX =
  /^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

function checkEmail(email: string): boolean {
  return EMAIL_REGEX.test(email)
}

const PASSWORD_HAS_NUMBER_REGEX = /[0-9]/
const PASSWORD_HAS_SPECIAL_CHAR_REGEX = /[!@#$%^&*]/

export type PasswordCheckResult = {
  hasNumber: boolean
  hasSpecialChar: boolean
  hasMinLength: boolean
}

/**
 * Returns password requirement checks. Use Object.values(checkPassword(pwd)).every(Boolean) for pass/fail.
 */
export function checkPassword(password: string): PasswordCheckResult {
  return {
    hasNumber: PASSWORD_HAS_NUMBER_REGEX.test(password),
    hasSpecialChar: PASSWORD_HAS_SPECIAL_CHAR_REGEX.test(password),
    hasMinLength: password.length >= 10,
  }
}

export default {
  checkEmail,
  checkPassword,
}
